<p-accordion [multiple]="true" [activeIndex]="activeTabIndices" [multiple]="true" styleClass="itemization-accordion bg-neutral-0 mb-3">
    <!-- Upload Itemizations -->
    <p-accordionTab header="Upload Itemizations">
        <!-- Upload Itemizations -->
        <form>
            <div class="formgrid grid mb-3">
                <div class="col-12 xl:col-8 xxl:col-6">
                    <p>
                        <a href="#" (click)="downloadTemplate($event)" class="p-text-primary">
                            <b>Download template file</b>
                        </a>,
                        add your data, upload updated file for staging, review and fix any
                        errors or warnings, and then save your itemizations.
                    </p>
                    <p-fileUpload 
                        #fileUploader 
                        [auto]="false" 
                        [showUploadButton]="true" 
                        customUpload="true"
                        accept=".xlsx" 
                        [maxFileSize]="5000000" 
                        chooseLabel="Select File"
                        uploadLabel="Stage Itemizations" 
                        (uploadHandler)="onFileUpload($event)"
                        (onClear)="onClear()">
                    </p-fileUpload>
                </div>

                <div class="col-12 xl:col-4 xxl:col-6"
                    style="border: 1px solid #a12525; border-radius: 6px; padding: 1rem;"
                    *ngIf="uploadResponse != null">
                    <p><b>File Name:</b> {{uploadResponse.fileName}}</p>
                    <p class="ui-success-60"><b>Rows staged:</b> {{uploadResponse.stageRows}}</p>
                    <p *ngIf="uploadResponse.errorCount>0" class="ui-danger-80"><b>Errors:</b>
                        {{uploadResponse.errorCount}}</p>
                    <p *ngIf="uploadResponse.warningCount>0" class="ui-warning-80"><b>Warnings:</b>
                        {{uploadResponse.warningCount}}</p>
                    <div *ngIf="uploadResponse" class="flex py-3">
                        <p-button *ngIf="uploadResponse.errorCount>0" [outlined]="true" label="Error List"
                            icon="fa-sharp fa-light fa-download" class="mr-2"
                            (click)="onErrorFile(uploadResponse,$event)" />
                        <p-button *ngIf="uploadResponse.warningCount>0" [outlined]="true" label="Warning List"
                            icon="fa-sharp fa-light fa-download" severity="warning"
                            (click)="onWarningFile(uploadResponse,$event)" />
                    </div>
                </div>

                <div *ngIf="stageditemizations.length>0" class="field col-12 mt-5">
                    <p-table [value]="stageditemizations" styleClass="rc-datatable-outlined">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Row</th>
                                <th>Vendor</th>
                                <th>Address</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Account</th>
                                <th>Description</th>
                                <th>Event</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr>
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.vendorID || '—' }}</td>
                                <td>{{ item.address1 }} {{item.address2}} {{item.city}} {{item.state}} {{item.zip}}</td>
                                <td>{{ item.disbursementDate| date:'MM/dd/yyyy' }}</td>
                                <td>{{ item.disbursementAmount | currency }}</td>
                                <td>{{ item.glNumber || '—'}}</td>
                                <td>{{ item.fecDescription || '—' }}</td>
                                <td>{{ item.eventCode || '—'}}</td>
                            </tr>
                        </ng-template>

                    </p-table>
                </div>

                <div *ngIf="uploadResponse" class="flex field col-12">
                    <p-button [disabled]="uploadResponse!=null && uploadResponse.errorCount > 0"
                        label="Save Staged Itemizations" class="mr-2" severity="secondary"
                        (click)="onSaveItemization()" />
                    <p-button [outlined]="true" label="Clear Staged Data" severity="secondary" (click)="onClear()" />
                </div>
            </div>
        </form>
    </p-accordionTab>

    <!-- Saved Itemizations -->
    <p-accordionTab header="Saved Itemizations">
        <form>
            <div class="formgrid grid pt-2">
                <div class="col-12 lg:col-8">
                    <p-message *ngIf="showWarning" severity="warn" text="Warning: The total amount of itemizations is greater than the requested amount." styleClass="mb-3"></p-message>
                </div>
                <div class="col-12 lg:col-4 lg:flex lg:justify-content-end align-items-center gap-2 mb-3">
                    <p-button label="Add Item" (click)="onAddItemization()" />
                    <p-button *ngIf="itemizations" [outlined]="true" label="Delete All" class="mr-2"
                        (click)="onDeleteAll()" />
                </div>
                <div *ngIf="itemizations.length>0" class="field col-12">
                    <p-table [value]="itemizations" styleClass="rc-datatable-outlined">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Vendor</th>
                                <th>Address</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Account</th>
                                <th>Description</th>
                                <th>Event</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr>
                                <td>{{ item.lineItem_VendorId }}</td>
                                <td>{{ item.lineItem_VendorAddress }}</td>
                                <td>{{ item.paymentDate | date:'MM/dd/yyyy' }}</td>
                                <td>{{ item.lineItem_RequestedAmount | currency }}</td>
                                <td>
                                    <div>{{ item.glAccountDisplayText }}</div>
                                </td>
                                <td>{{ item.description || '—' }}</td>
                                <td>{{ item.eventDescription }}</td>
                                <td style="white-space: nowrap;">
                                    <rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light"
                                        [isIconOnly]="true" (click)="editLineItemDialog(item)" />
                                    <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light"
                                        [isIconOnly]="true" (click)="deleteLineItem(item)" />
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <tr>
                                <td colspan="3"></td>
                                <td><b>Total:</b> {{ totalAmount | currency }}</td>
                                <td colspan="4"></td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </form>
    </p-accordionTab>
</p-accordion>

<p-card>
    <p-button [outlined]="true" severity="secondary" label="Previous" (onClick)="prevCallback.emit()" />
</p-card>


<!-- Add/Edit Line Item MODAL -->
<p-dialog [(visible)]="itemizationDialog" 
    header="{{ isEdit ? 'Edit Line Item' : 'Add Line Item' }}" 
    [modal]="true"
    [maximizable]="true"
    styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

    <ng-container *ngIf="itemizationDialog">
        <p-card>
            <form [formGroup]="expenseitemizationForm" (ngSubmit)="saveItemization(isEdit)">
                <input type="hidden" formControlName="requestId" />
                <input type="hidden" formControlName="lineItemId" />
                <input type="hidden" formControlName="lineItem_CampaignId" />
                <input type="hidden" formControlName="isMemo" />
                <div class="formgrid grid">
                    <div class="field col-12 lg:col-6">
                        <label for="vendorId" class="field-label required">
                            Vendor
                        </label>
                        <p-autoComplete id="vendor" formControlName="vendor" [suggestions]="vendorSuggestions"
                            (completeMethod)="searchVendor($event.query)" (onSelect)="onVendorSelect($event)"
                            placeholder="Type to Search"></p-autoComplete>
                        <div>
                            <small
                                *ngIf="expenseitemizationForm.get('vendor')?.invalid && expenseitemizationForm.get('vendor')?.touched"
                                class="p-error">Vendor is required.</small>
                        </div>
                    </div>
                    <div class="field col-12 lg:col-6">
                        <label for="paymentDate" class="field-label required">
                            Disbursment Date
                        </label>
                        <p-calendar id="paymentDate" formControlName="paymentDate" [showIcon]="true"
                            [iconDisplay]="'input'" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY"></p-calendar>
                        <small
                            *ngIf="expenseitemizationForm.get('paymentDate')?.invalid && expenseitemizationForm.get('paymentDate')?.touched"
                            class="error">
                            Disbursment Date is required.
                        </small>
                    </div>
                    <div class="field col-12 lg:col-6">
                        <label for="lineItem_RequestedAmount" class="field-label required">Disbursment
                            Amount</label>
                        <input id="lineItem_RequestedAmount"
                               formControlName="lineItem_RequestedAmount"
                               type="text"
                               pInputText
                               name="lineItem_RequestedAmount"
                               required
                               (input)="onAmountInput($event)" />
                        <div>
                            <small
                                *ngIf="expenseitemizationForm.get('lineItem_RequestedAmount')?.invalid && expenseitemizationForm.get('lineItem_RequestedAmount')?.touched"
                                class="p-error">Requested Amount is required.</small>
                        </div>
                    </div>
                    <div class="field col-12 lg:col-6">
                        <label for="event">Event</label>
                        <p-autoComplete id="event" formControlName="event" [suggestions]="eventSuggestions"
                            (completeMethod)="searchEvent($event.query)" (onSelect)="onEventSelect($event)"
                            placeholder="Type to Search"></p-autoComplete>
                    </div>
                    <div class="field col-12 lg:col-6">
                        <label for="account" class="field-label required">GL</label>
                        <p-autoComplete id="account" formControlName="account" [suggestions]="accountSuggestions"
                            (completeMethod)="searchAccount($event.query)" (onSelect)="onAccountSelect($event)"
                            placeholder="Type to Search"></p-autoComplete>
                        <div>
                            <small
                                *ngIf="expenseitemizationForm.get('account')?.invalid && expenseitemizationForm.get('account')?.touched"
                                class="p-error">GL is required.</small>
                        </div>
                    </div>
                    <div class="field col-12 lg:col-6">
                        <label for="description" class="field-label">Description</label>
                        <input id="description" formControlName="description" type="text" pInputText />
                    </div>
                </div>
            </form>
        </p-card>
    </ng-container>
    <ng-template pTemplate="footer">
        <p-button type="button" label="Cancel" (onClick)="onCancelItemization()" [text]="true" />
        <p-button type="button" label="Save" (onClick)="saveItemization(isEdit)" />
    </ng-template>
</p-dialog>
